import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PageRefreshIconsModule } from './page-refresh-icons.module';

@Component({
  selector: 'app-page-refresh-btn',
  standalone: true,
  imports: [PageRefreshIconsModule],
  template: `
    <button
      type="button"
      class="btn secondary page-refresh-btn"
      [class.page-refresh-btn--loading]="loading"
      [disabled]="disabled || loading"
      [attr.aria-busy]="loading || null"
      [attr.aria-label]="loading ? 'Refreshing' : 'Refresh'"
      (click)="refresh.emit()"
    >
      <lucide-icon name="rotate-cw" [size]="18" [strokeWidth]="2" />
    </button>
  `,
})
export class PageRefreshButtonComponent {
  @Input() loading = false;
  @Input() disabled = false;
  @Output() readonly refresh = new EventEmitter<void>();
}
